<profile-section>
  <ng-container slot="title" i18n>Mes qualités</ng-container>

  <div class="soft-skills">
    <div class="soft-skills__item" *ngFor="let item of profile?.softSkills; trackBy: trackByKey">
      <profile-i18n-soft-skill [model]="item"></profile-i18n-soft-skill>
    </div>
  </div>
</profile-section>
